<div class="modal" id="driverModalAdd" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header">
				<button type="button" class="btn-close" (click)="dialogClose()"></button>
			</div>
			<div class="modal-body">
				<div class="col">
					<label for="program_date_from">Kierowca</label>
					<ng-select placeholder="(wybierz)" bindLabel="name" required [(ngModel)]="driver">
						<ng-option *ngFor="let item of drivers" [value]="item.id"
							>{{ item.last_name }} {{ item.first_name }}</ng-option
						>
					</ng-select>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" (click)="submit()">Zapisz</button>
				<button type="button" class="btn btn-secondary" (click)="dialogClose()">Anuluj</button>
			</div>
		</div>
	</div>
</div>
